import React from "react";
import { Col, Row } from "react-bootstrap";
import { Skeleton } from "components";

export default function HeroSkeleton() {
  return (
    <Row className="align-items-center">
      <Col xl={6} lg={6} xs={12} className="hero_text">
        {/* Hero Slider Transitions text */}
        <Skeleton count={2} height={10} width={"50%"} className="mb-4" />
        <Skeleton count={3} height={10} width={"80%"} />
      </Col>
      <Col xl={6} lg={6} xs={12} className="position-relative mt-4 mt-xlg-0">
        {/* image Slider */}
        <div className="slider-3d">
          <div className="slider-container">
            <div className="slider-content">
              <Skeleton count={1} height={270} width={"80%"} />
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
}
